import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
interface PDFModalProps {
  isOpen: boolean;
  onClose: () => void;
  pdfUrl: string;
  title: string;
}
export function PDFModal({
  isOpen,
  onClose,
  pdfUrl,
  title
}: PDFModalProps) {
  // Close on ESC key
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center" data-id="element-1137">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-navy/90 backdrop-blur-sm" onClick={onClose} data-id="element-1138" />

      {/* Modal */}
      <div className="relative bg-white rounded-lg shadow-2xl w-full max-w-6xl h-[90vh] mx-4 flex flex-col" data-id="element-1139">
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200" data-id="element-1140">
          <h3 className="text-lg font-bold text-navy" data-id="element-1141">{title}</h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full transition-colors" aria-label="Close modal" data-id="element-1142">
            <XIcon className="h-6 w-6 text-gray-600" data-id="element-1143" />
          </button>
        </div>

        {/* PDF Viewer */}
        <div className="flex-1 overflow-hidden" data-id="element-1144">
          <iframe src={pdfUrl} className="w-full h-full" title={title} data-id="element-1145" />
        </div>

        {/* Footer with Download Button */}
        <div className="p-4 border-t border-gray-200 flex justify-end" data-id="element-1146">
          <a href={pdfUrl} download className="inline-flex items-center bg-amber hover:bg-amber-dark text-navy font-bold px-6 py-3 rounded transition-colors" data-id="element-1147">
            Download PDF
          </a>
        </div>
      </div>
    </div>;
}